import React from "react";
import { ArrowDownIcon } from "lucide-react";
type OfferLinkProps = {
  children: React.ReactNode;
  variant?: "primary" | "outline";
  className?: string;
};

// Bouton informatif : fait défiler la page jusqu'à la section offre.
export function OfferLink({
  children,
  variant = "primary",
  className = ""
}: OfferLinkProps) {
  const base = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-extrabold tracking-wide transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta";
  const styles = variant === "primary" ? "bg-terracotta px-7 py-4 text-sm text-white hover:bg-terracotta-dark md:text-base" : "border-2 border-ink/80 px-6 py-3 text-sm text-ink hover:bg-ink hover:text-cream";
  return <a href="#offre" className={`${base} ${styles} ${className}`} data-id="element-124" data-mp="gen26d6d63in">
      {children}
      {variant === "outline" && <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="mgnku75u5117" />}
    </a>;
}